module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_5000_10000.3ff13f5b.png";